
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';

    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Imagen } from '@/__env/lib/MercadoLibre/Publicaciones';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Publicacion() { return this.Controlador.Publicacion; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public Seleccionada: Imagen = null;
        public Imagenes: Imagen[] = [];

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( x => this.Iniciar() ) );
            this.Iniciar();
        }

        Iniciar()
        {
            if ( this.Estado != 'iniciado' )
                return;

            this.Imagenes.clear();
            if ( this.Publicacion.Imagenes.hasRows() )
            {
                this.Imagenes.push( ...this.Publicacion.Imagenes );

                if ( this.Publicacion.Video )
                {
                    let ea = new Imagen();
                    ea.Link = this.Publicacion.Video;
                    ea.esVideo = true;
                    this.Imagenes.push( ea );
                }
                this.Seleccionada = this.Imagenes[0];
            }
        }

    }
